import { getTokenMutation } from './graphql/getTokenMutation'
import { graphqlFetch } from '@pylot-data/graphqlFetch'
import type { CustomerToken } from '@pylot-data/fwrdschema'
import { useAccount } from './use-account'
import { CUSTOMER_QUERY } from './graphql/customerQuery'
import { useRouter } from 'next/router'
import { useState } from 'react'
import { useAuthUI } from './AuthContext'
import { loginEvent } from '@lib/utils/exponeaTrackingEvents'
import { mutate as globalMutate } from 'swr'

export type GenerateTokenResponse = {
    data: CustomerToken
}

export type LoginArguments = {
    email: string
    password: string
}

export const useLogin = () => {
    const { mutate: fetchAccountInfo } = useAccount()
    const { locale } = useRouter()
    const { loginCallbacks, clearAuthCallback } = useAuthUI()

    const [isLoading, setIsLoading] = useState(false)

    return {
        login: async (params: LoginArguments) => {
            setIsLoading(true)
            const res = await graphqlFetch<
                LoginArguments,
                { generateCustomerToken: CustomerToken }
            >({
                query: getTokenMutation,
                variables: params,
                locale
            })
            if (res.errors) {
                setIsLoading(false)
                throw res.errors
            }
            localStorage.setItem(
                'pylot_token',
                res.data!.generateCustomerToken.token!
            )
            loginEvent({ email: params.email })
            // Activa la key SWR de customer (antes podía quedar en null) y revalida.
            window.dispatchEvent(new CustomEvent('pylot:refresh-content'))
            const result = await Promise.all([
                globalMutate([CUSTOMER_QUERY]),
                fetchAccountInfo()
            ])
            setIsLoading(false)
            //handle login callbacks
            if (loginCallbacks.length) {
                loginCallbacks.forEach((callback) => {
                    if (typeof callback === 'function') {
                        callback()
                    }
                })
                clearAuthCallback('LOGIN_VIEW')
            }

            return result
        },
        isLoading
    }
}
